<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button style="margin-right: 1px" size="mini" @click="toPrint">打印</el-button>
    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
<!--          <el-input size="mini"-->
<!--                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
<!--                    placeholder="输入关键字进行过滤"-->
<!--                    v-model="productTypeFilterText">-->
<!--          </el-input>-->
          <el-card class="box-card">
            <el-tree
              :data="productTypeList"
              :props="productTypeProps"
              @node-click="productTypeHandleNodeClick"
              :highlight-current="true"
              node-key="id"
              :filter-node-method="productTypeFilterNode"
              default-expand-all
              ref="productTree"
            >
            </el-tree>
          </el-card>
        </div>
      </div>
      <div class="table_container" style="margin: 10px 0">
        <el-card class="box-card">
          <div id="printMe">
          <el-table height="550px" :data="productList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}" >
            <el-table-column
              align="center"
              prop="userName"
              fixed="fixed"
              label="操作" width="100">
              <template slot-scope="scope">
                <el-link type="primary" v-if="authorities.includes('storage.stock.check.pandian')"
                         icon="iconfont icon-kucunpandian-"
                         @click="showCheckStockDialog(scope.row)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="productName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              align="center"
              prop="productNo"
              label="产品编号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="psm"
              label="规格型号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="unit"
              label="单位">
            </el-table-column>
            <el-table-column
              align="center"
              prop="nowNum"
              label="现有库存"
              v-if="(orgLevel-0) === 3"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="practicalNum"
              label="实际库存">
            </el-table-column>
          </el-table>
          </div>
        </el-card>
      </div>


      <!-- 盘点 -->
      <el-dialog
        title="盘点"
        :visible.sync="checkStockDialogVisible"
        width="60%"
        @close="closeCheckStockDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>

        <div style="height: 50px;margin-top: 10px;display: flex;justify-content: space-between">
          <div>
            <span >产品名称： </span>
            <el-input style="width: 300px" disabled v-model="checkStock.productName" size="mini" />
          </div>
          <div>
            <span >盘点数量： </span>
            <el-input style="width: 300px" v-model="checkStock.num" size="mini"
                      onkeyup="value=value.replace(/[^\d]/g,'')"/>
          </div>
        </div>
        <div style="height: 150px;margin-top: 10px;display: flex;justify-content: space-between">
          <div>
            备注说明：
            <el-input v-model="checkStock.comment" style="width: 730px" type="textarea" size="mini" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeCheckStockDialog">取 消</el-button>
        <el-button size="mini" @click="createCheckStock">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      authorities:'',
      userId:'',
      orgLevel:'',
      productTypeFilterText:'',
      productTypeList:[],
      productTypeProps:{
        label: 'productTypeName',
        children: 'children'
      },
      productList:[],
      checkStockDialogVisible:false,
      checkStock:{
        productTypeId:'',
        productId:'',
        productName:'',
        num:'',
        comment:'',
        orgId:'',
        creator:''
      },
      createCheckStockDoubleClick:false
    }
  },
  methods:{
    toPrint(){
      this.$router.push('/stock/print')
    },
    async productTypeHandleNodeClick(data){
      this.checkStock.productTypeId = data.productTypeId;
      await this.loadProduct(data);
      // if (data.parentId !== '' && data.parentId !== 0 || data.productTypeName === '自采产品'){
      //
      // }
    },
    async loadProduct(data){
      const {data:res} = await this.$http.get(`stock/productTypeId/${data.id}/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.productList = res.data;
      }
    },
    productTypeFilterNode(value, data) {
      if (!value) return true;
      return data.productTypeName.indexOf(value) !== -1;
    },
    showCheckStockDialog(data){
      this.checkStock.num = '';
      this.checkStock.comment = '';
      this.checkStock.productName = data.productName;
      this.checkStock.productId = data.productId;
      this.checkStock.orgId = data.orgId;
      this.checkStock.productTypeId = data.productTypeId;
      this.checkStock.creator = this.userId;
      this.checkStockDialogVisible = true;
    },
    closeCheckStockDialog(){
      this.checkStockDialogVisible = false;
    },
    //加载产品分类
    async loadProductType(){
      const {data:res} = await this.$http.get(`productType/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.productTypeList = res.data;
      }
    },
    async createCheckStock(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/checkStock`, this.checkStock)
      if (res.code === 200){
        const {data:res1} = await this.$http.get(`stock/productTypeId/${this.checkStock.productTypeId}/orgId/${this.currentOrgId}`);
        if (res.code === 200){
          this.productList = res1.data;
        }
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeCheckStockDialog();
    }
  },
  watch: {
    productTypeFilterText(val) {
      this.$refs.productTree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadProductType();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 100%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/Stock.vue